import { StylesConfig } from 'react-select';
import { TagOption } from './services/api';

/**
 * Custom styles for the react-select component to match a hypothetical theme.
 * You can adjust these colors and values to fit your app's design.
 */
export const customSelectStyles: StylesConfig<TagOption, true> = {
    // The main container
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#fff',
        borderColor: state.isFocused ? '#4a90e2' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #4a90e2' : 'none',
        '&:hover': {
            borderColor: state.isFocused ? '#4a90e2' : '#aaa',
        },
        minHeight: '40px',
    }),

    // The dropdown menu
    menu: (provided) => ({
        ...provided,
        borderRadius: '4px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    }),

    // The items in the dropdown menu
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#4a90e2'
            : state.isFocused
                ? '#e9f2fa'
                : '#fff',
        color: state.isSelected ? '#fff' : '#333',
        '&:active': {
            backgroundColor: '#4a90e2',
            color: '#fff',
        },
    }),

    // The selected tags (pills)
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#e9f2fa',
        borderRadius: '4px',
    }),

    // The text inside a selected tag
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#0d47a1',
        fontWeight: 500,
        padding: '3px 6px',
    }),

    // The 'x' button to remove a tag
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#0d47a1',
        borderRadius: '0 4px 4px 0',
        '&:hover': {
            backgroundColor: '#d0e0f0',
            color: '#0d47a1',
        },
    }),

    // The placeholder text
    placeholder: (provided) => ({
        ...provided,
        color: '#888',
    }),
};